export const THEME_LIST = [
    'light',
    'dark',
    'cupcake',
    'bumblebee',
    'emerald',
    'charles',
    'ocean',
    'sunrise',
    'lavender',
    'midnight',
    'neon',
    'mint',
    'harmony',
    'breeze',
    'blossom',
    'pinker',
    'corporate',
    'synthwave',
    'retro',
    'cyberpunk',
    'valentine',
    'halloween',
    'garden',
    'forest',
    'aqua',
    'lofi',
    'pastel',
    'fantasy',
    'wireframe',
    'black',
    'luxury',
    'dracula',
    'cmyk',
    'autumn',
    'business',
    'acid',
    'lemonade',
    'night',
    'coffee',
    'winter',
    'dim',
    'nord',
    'sunset'
]

export const THEME_COLOR_MAP = {
    'light': '#f2f2f2',
    'dark': '#1a1e23',
    'cupcake': '#eeeae6',
    'bumblebee': '#e8e8e8',
    'emerald': '#e8e8e8',
    'corporate': '#e8e8e8',
    'synthwave': '#150e34',
    'retro': '#e2d8b8',
    'cyberpunk': '#e7dc5f',
    'valentine': '#e0d2dd',
    'halloween': '#1d1d1d',
    'garden': '#d3d2d2',
    'forest': '#130f0f',
    'aqua': '#375393',
    'lofi': '#f2f2f2',
    'pastel': '#f9fafb',
    'fantasy': '#e8e8e8',
    'wireframe': '#eeeeee',
    'black': '#141414',
    'luxury': '#171618',
    'dracula': '#24252f',
    'cmyk': '#e8e8e8',
    'autumn': '#dbdbdb',
    'business': '#1c1c1c',
    'acid': '#e3e3e3',
    'lemonade': '#e2e6da',
    'night': '#0e1424',
    'coffee': '#1b131b',
    'winter': '#f3f7fe',
    'dim': '#252932',
    'nord': '#e6e9ef',
    'sunset': '#10171d'
}
